export const ERROR_CODES = {
  createItemForPieceIsNotAllowedError: 'createItemForPieceIsNotAllowedError',
  createPiecePendingOrderError: 'createPiecePendingOrderError',
  forbiddenDeleteSystemValues: 'forbiddenDeleteSystemValues',
  forbiddenDeleteUsedValue: 'forbiddenDeleteUsedValue',
  holdingsByIdNotFoundError: 'holdingsByIdNotFoundError',
  locationIdAndHoldingIdAbsentError: 'locationIdAndHoldingIdAbsentError',
  mayBeLinkToEitherHoldingOrLocationError: 'mayBeLinkToEitherHoldingOrLocationError',
  missingHoldingsSourceId: 'missingHoldingsSourceId',
  multipleNonPackageTitles: 'multipleNonPackageTitles',
  partiallyReturnedCollection: 'partiallyReturnedCollection',
  pgException: 'pgException',
  pieceAlreadyReceived: 'pieceAlreadyReceived',
  pieceFormatIsNotValid: 'pieceFormatIsNotValid',
  pieceNotFound: 'pieceNotFound',
  pieceNotRetrieved: 'pieceNotRetrieved',
  piecePolMismatch: 'piecePolMismatch',
  pieceUpdateFailed: 'pieceUpdateFailed',
  receivingProcessEncumbrancesError: 'receivingProcessEncumbrancesError',
  titleNotFound: 'titleNotFound',
  userHasNoPermission: 'userHasNoPermission',
  userNotAMemberOfTheAcq: 'userNotAMemberOfTheAcq',
  barcodeIsNotUnique: 'barcodeIsNotUnique',
};
